// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.backpack_backpack-container_H0IKY {
    flex-shrink: 1;
    position: relative;
}

.backpack_backpack-header_Gay3u {
    margin-top: 0.5rem;
    border: 1px solid var(--ui-black-transparent);
    background: var(--ui-white);
    padding: 0.25rem;
    text-align: center;
    font-size: 0.85rem;
    color: var(--text-primary);
    transition: 0.2s;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

[dir="ltr"] .backpack_backpack-header_Gay3u {
    border-top-right-radius: 0.5rem;
}

[dir="rtl"] .backpack_backpack-header_Gay3u {
    border-top-left-radius: 0.5rem;
}

.backpack_backpack-list_Cth_9 {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-right: 1px solid var(--ui-black-transparent);
    min-height: 5.5rem;
}

/* Absolute position the inner list to allow scrolling inside flex sized container */

.backpack_backpack-list-inner_RAXLh {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
}

.backpack_drag-over_uwwc3:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.75;
    background-color: var(--drop-highlight);
    transition: all 0.25s ease;
}

.backpack_status-message_hNpAE {
    width: 100%;
    text-align: center;
    font-size: 0.85rem;
    color: var(--text-primary);
}

.backpack_error-message_BX0LX {
    font-family: monospace;
}

.backpack_backpack-item_ojrvd {
    width: 4rem;
    height: 4.5rem;
    margin: 0 0.25rem;
    flex-shrink: 0;

    /* Need to hide overflow because of background setting below */
    overflow: hidden;
}

.backpack_backpack-item_ojrvd > div {
    /* Need to set the background to get blend-mode below to work */
    background: var(--ui-primary);
}

.backpack_more_qP77W {
    background: var(--looks-secondary);
    color: var(--ui-white);
    border: none;
    outline: none;
    font-weight: bold;
    border-radius: 0.5rem;
    font-size: 0.85rem;
    padding: 0.5rem;
    margin: 0.5rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/backpack/backpack.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mDAAmD;IACnD,kBAAkB;AACtB;;AAEA,oFAAoF;;AAEpF;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,cAAc;;IAEd,8DAA8D;IAC9D,gBAAgB;AACpB;;AAEA;IACI,+DAA+D;IAC/D,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.backpack-container {\n    flex-shrink: 1;\n    position: relative;\n}\n\n.backpack-header {\n    margin-top: 0.5rem;\n    border: 1px solid var(--ui-black-transparent);\n    background: var(--ui-white);\n    padding: 0.25rem;\n    text-align: center;\n    font-size: 0.85rem;\n    color: var(--text-primary);\n    transition: 0.2s;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n[dir=\"ltr\"] .backpack-header {\n    border-top-right-radius: 0.5rem;\n}\n\n[dir=\"rtl\"] .backpack-header {\n    border-top-left-radius: 0.5rem;\n}\n\n.backpack-list {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border-right: 1px solid var(--ui-black-transparent);\n    min-height: 5.5rem;\n}\n\n/* Absolute position the inner list to allow scrolling inside flex sized container */\n\n.backpack-list-inner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow-x: auto;\n}\n\n.drag-over:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.75;\n    background-color: var(--drop-highlight);\n    transition: all 0.25s ease;\n}\n\n.status-message {\n    width: 100%;\n    text-align: center;\n    font-size: 0.85rem;\n    color: var(--text-primary);\n}\n\n.error-message {\n    font-family: monospace;\n}\n\n.backpack-item {\n    width: 4rem;\n    height: 4.5rem;\n    margin: 0 0.25rem;\n    flex-shrink: 0;\n\n    /* Need to hide overflow because of background setting below */\n    overflow: hidden;\n}\n\n.backpack-item > div {\n    /* Need to set the background to get blend-mode below to work */\n    background: var(--ui-primary);\n}\n\n.more {\n    background: var(--looks-secondary);\n    color: var(--ui-white);\n    border: none;\n    outline: none;\n    font-weight: bold;\n    border-radius: 0.5rem;\n    font-size: 0.85rem;\n    padding: 0.5rem;\n    margin: 0.5rem;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `backpack_backpack-container_H0IKY`;
export { _1 as "backpack-container" };
export var backpackContainer = `backpack_backpack-container_H0IKY`;
var _2 = `backpack_backpack-header_Gay3u`;
export { _2 as "backpack-header" };
export var backpackHeader = `backpack_backpack-header_Gay3u`;
var _3 = `backpack_backpack-list_Cth_9`;
export { _3 as "backpack-list" };
export var backpackList = `backpack_backpack-list_Cth_9`;
var _4 = `backpack_backpack-list-inner_RAXLh`;
export { _4 as "backpack-list-inner" };
export var backpackListInner = `backpack_backpack-list-inner_RAXLh`;
var _5 = `backpack_drag-over_uwwc3`;
export { _5 as "drag-over" };
export var dragOver = `backpack_drag-over_uwwc3`;
var _6 = `backpack_status-message_hNpAE`;
export { _6 as "status-message" };
export var statusMessage = `backpack_status-message_hNpAE`;
var _7 = `backpack_error-message_BX0LX`;
export { _7 as "error-message" };
export var errorMessage = `backpack_error-message_BX0LX`;
var _8 = `backpack_backpack-item_ojrvd`;
export { _8 as "backpack-item" };
export var backpackItem = `backpack_backpack-item_ojrvd`;
export var more = `backpack_more_qP77W`;
export default ___CSS_LOADER_EXPORT___;
